import "./datatable.scss";
import * as config from '../../common/config'
import Select from "react-select";
import { optionsReceiptTime } from '../../common/constant';
export default function DataTableButtonsFunction(props) {
    const {
        rowsPerPage,
        handleChangeRowsPerPage,
        sumary,
        configLocal,
        getList,
        getSumary,
        searchData,
        hideButtons,
        customButtons
    } = props;
    return (
        <div className="row">
            <div className="col-12 col-md-9 mb-2">
                {sumary ?
                    <div className="dt-buttons d-flex" style={{ gap: "5px" }}>
                        <table className="table table-bordered table-hover">
                            <tbody>
                                <tr>
                                    {
                                        sumary?.sumaryShipperCuisine ?
                                            <td>Đã nhận giao: <b>{sumary?.sumaryShipperCuisine}</b> - <span className="text-primary">Trưa: <b>{sumary?.sumaryShipperLunch}</b></span> - <span className="text-danger">Chiều: <b>{sumary?.sumaryShipperDinner}</b></span></td> :
                                            (sumary?.sumaryCuisineOrder ? <td>Tổng SL đơn: <b>{sumary?.sumaryCuisineOrder}</b> - <span className="text-primary">Trưa: <b>{sumary?.sumaryLunchOrder}</b></span> - <span className="text-danger">Chiều: <b>{sumary?.sumaryDinnerOrder}</b></span></td> : <></>)
                                    }
                                    <td>Tổng suất ăn: <b>{sumary?.sumaryCuisineQuatity}</b> - <span className="text-primary">Trưa: <b>{sumary?.sumaryLunch}</b></span> - <span className="text-danger">Chiều: <b>{sumary?.sumaryDinner}</b></span></td>
                                    <td>
                                        <Select
                                            isClearable
                                            //{...register("receiptTime", {})}
                                            placeholder="Thời gian nhận"
                                            closeMenuOnSelect={true}
                                            onChange={(data) => getList ? getList(1, configLocal.defaultPageSize, configLocal.sortExpression, { ...searchData, receiptTime: data ? data.value : null }) : getSumary ? getSumary({ ...searchData, receiptTime: data ? data.value : null }) : null}
                                            options={optionsReceiptTime}
                                            noOptionsMessage={() => "Không tồn tại"}
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            isSearchable={false}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> :
                    <div className="dt-buttons d-flex" style={{ gap: "5px" }}>
                        {!hideButtons && <>
                            <button className="btn btn-outline-light buttons-copy" tabIndex="0" aria-controls="table_buttons_extension" type="button">
                                <span>Copy</span>
                            </button>
                            <button className="btn btn-outline-light buttons-excel" tabIndex="0" aria-controls="table_buttons_extension" type="button">
                                <span>Excel</span>
                            </button>
                            <button className="btn btn-outline-light buttons-pdf" tabIndex="0" aria-controls="table_buttons_extension" type="button">
                                <span>PDF</span>
                            </button>
                            <button className="btn btn-outline-light buttons-print" tabIndex="0" aria-controls="table_buttons_extension" type="button">
                                <span>In</span>
                            </button>
                            <button className="btn btn-outline-light buttons-collection dropdown-toggle buttons-colvis" tabIndex="0" aria-controls="table_buttons_extension" type="button" aria-haspopup="true">
                                <span>Ẩn/ hiện cột</span>
                            </button>
                        </>}
                        {customButtons}
                    </div>}

            </div>
            <div className="col-12 col-md-3 mb-2 ">
                <label className='d-flex align-items-end justify-content-end' style={{ gap: "10px" }}>
                    Xem
                    <select
                        className="custom-select custom-select-sm form-control form-control-sm"
                        style={{ width: "50px" }}
                        value={rowsPerPage}
                        onChange={handleChangeRowsPerPage}
                    >
                        {config.Configs.DefaultPageSizeOption.map((pageSize, index) => (
                            <option key={index} value={pageSize}>{pageSize}</option>
                        ))}
                    </select>
                    mục
                </label>
            </div>
        </div>
    )
}